import { z } from "zod";
export const AuthenticatorAlgorithmSchema = z.enum(["SHA1", "SHA256", "SHA512"]);
const StoredBase32SecretSchema = z
    .string()
    .min(8)
    .max(256)
    .regex(/^[A-Z2-7]+=*$/i, "Secret must be a Base32 value");
const Base32SecretInputSchema = z
    .string()
    .transform((value) => value.replace(/\s/g, "").toUpperCase())
    .pipe(StoredBase32SecretSchema);
export const AuthenticatorEntrySchema = z.object({
    id: z.string().uuid(),
    issuer: z.string().min(1).max(160),
    accountName: z.string().max(320).nullable(),
    secret: StoredBase32SecretSchema,
    algorithm: AuthenticatorAlgorithmSchema,
    digits: z.number().int().min(6).max(8),
    period: z.number().int().min(15).max(120),
    ownerEmail: z.string().email(),
    sharedWith: z.array(z.string().email()),
    isOwner: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const AuthenticatorListResponseSchema = z.object({
    entries: z.array(AuthenticatorEntrySchema),
});
export const AuthenticatorCreateSchema = z.object({
    issuer: z.string().trim().min(1).max(160),
    accountName: z.string().trim().max(320).optional().default(""),
    secret: Base32SecretInputSchema,
    algorithm: AuthenticatorAlgorithmSchema.default("SHA1"),
    digits: z.coerce.number().int().min(6).max(8).default(6),
    period: z.coerce.number().int().min(15).max(120).default(30),
});
export const AuthenticatorShareSchema = z.object({
    sharedWith: z.array(z.string().trim().toLowerCase().email()).max(25).default([]),
});
export const AuthenticatorDeleteResponseSchema = z.object({
    deleted: z.literal(true),
});
//# sourceMappingURL=authenticator.js.map